import { getLS, LocalStorageTypes } from '@/common/service/storage';
import wishlist_dark from '@/shared/images/Images/wishlist_dark.png';
import wishlist_white from '@/shared/images/Images/wishlist_white.png';
import Image from 'next/image';
import * as S from './WishList.styles';
import { PayPalSection } from '@/common/ui/styled/PayPalSection/PayPalSection';

const Empty = () => {
    const clientTheme = getLS(LocalStorageTypes.LS_THEME_MODE);
    const isDark: boolean = clientTheme === 'dark';

    return (
        <S.EmptyWishlist>
            <S.EmptyWishlistImage>
                <Image
                    src={isDark ? wishlist_dark.src : wishlist_white.src}
                    layout={'fill'}
                    alt={'wishlist'}
                />
            </S.EmptyWishlistImage>
            <S.WishDescription>
                <S.EmptyWishlistFirstText>
                    When you see something you like, click on
                    <S.IconWrapper>
                        <S.WishListBtn />
                    </S.IconWrapper>
                </S.EmptyWishlistFirstText>
                <S.EmptyWishlistSecondText>
                    icon and we will save it here.
                </S.EmptyWishlistSecondText>
            </S.WishDescription>
            <PayPalSection />
        </S.EmptyWishlist>
    );
};

export default Empty;
